import React, { Fragment, useState, useEffect } from 'react';
import moment from 'moment';
// store
import { authService } from "../../../../store/services/ServiceAuth";
import { paymentService } from "../../../../store/services/ServicePayment";
// components
import HeaderTitle from "../../../../components/others/HeaderTitle";
import Loading from "../../../../components/others/Loading";
import { Form, Button, Card, Icon } from "semantic-ui-react";
import { DateInput } from "semantic-ui-calendar-react";
import StornoRecordsTable from './StornoRecordsTable';

const MyStorno = () => {
    authService.useIsProvider();

    const [isLoading, setIsLoading] = useState(true)
    const [filters, setFilters] = useState({
        from: moment().startOf('month').format("DD.MM.YYYY"),
        to: moment().endOf('month').format("DD.MM.YYYY"),
    })
    const [records, setRecords] = useState([])
    const [isMobile, setIsMobile] = useState(false);
    const [showFilters, setShowFilters] = useState(false);
    // eslint-disable-next-line
    const [view, setView] = useState(1)

    async function fetchRecords() {
        setIsLoading(true);

        let params = "?q="
        if (filters.from) params += `&from=${moment(filters.from, "DD.MM.YYYY").format("YYYY-MM-DD")}`
        if (filters.to) params += `&to=${moment(filters.to, "DD.MM.YYYY").format("YYYY-MM-DD")}`

        const request = await paymentService.getProviderStornos(params)

        if (request.status === 200) {
            setRecords(request.response)
        }

        setIsLoading(false);
    }

    const handleFilter = async () => {
        await fetchRecords()
        if (isMobile) {
            setShowFilters(false)
        }
    }

    useEffect(() => {
        fetchRecords()
        // eslint-disable-next-line
    }, [view])

    useEffect(() => {
        const media = window.matchMedia("(max-width: 768px)");
        const handleChange = () => setIsMobile(media.matches);
        handleChange();
        if (media.addEventListener) {
            media.addEventListener("change", handleChange);
        } else {
            media.addListener(handleChange);
        }
        return () => {
            if (media.removeEventListener) {
                media.removeEventListener("change", handleChange);
            } else {
                media.removeListener(handleChange);
            }
        };
    }, [])

    return (
        <Fragment>
            <HeaderTitle title="Prehľad refundácií" />
            <section>
                {isMobile && (
                    <div style={{ marginBottom: "1rem" }}>
                        <div
                            onClick={() => setShowFilters(!showFilters)}
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                padding: "0.85rem 1rem",
                                background: "#f8f9fa",
                                border: "1px solid #e0e0e0",
                                borderRadius: "8px",
                                cursor: "pointer",
                                transition: "all 0.2s ease"
                            }}
                        >
                            <div style={{ display: "flex", gap: "0.65rem" }}>
                                <Icon name="sliders horizontal" style={{ margin: 0, fontSize: "1.05rem", color: "#555" }} />
                                <span style={{ fontSize: "0.95rem", fontWeight: 600, color: "#333" }}>Filtrovať</span>
                            </div>
                            <div style={{ display: "flex", gap: "0.6rem" }}>
                                <span style={{ fontSize: "0.85rem", color: "#666", fontWeight: 500 }}>{filters.from} - {filters.to}</span>
                                <Icon name={showFilters ? "chevron up" : "chevron down"} style={{ margin: 0, fontSize: "0.95rem", color: "#555" }} />
                            </div>
                        </div>
                    </div>
                )}

                {(showFilters || !isMobile) && (
                    <Card fluid style={{ borderRadius: "8px", border: "1px solid #e0e0e0", marginBottom: "1rem", boxShadow: "none", overflow: isMobile ? "visible" : "initial" }}>
                        <Card.Content style={{ padding: isMobile ? "1rem" : "1.25rem", overflow: isMobile ? "visible" : "initial" }}>
                            <Form onSubmit={handleFilter} style={{ overflow: isMobile ? "visible" : "initial" }}>
                                <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr auto", gap: isMobile ? "1rem" : "1rem", alignItems: "end", width: "100%", maxWidth: "100%" }}>
                                    <Form.Field style={{ margin: 0 }}>
                                        <label style={{ fontSize: "0.85rem", fontWeight: 600, color: "#555", marginBottom: "0.4rem", display: "block" }}>
                                            Dátum od
                                        </label>
                                        <DateInput
                                            fluid
                                            localization="sk"
                                            placeholder="DD.MM.YYYY"
                                            dateFormat="DD.MM.YYYY"
                                            value={filters.from}
                                            onChange={(e, { value }) => setFilters({ ...filters, from: value })}
                                            iconPosition="right"
                                            animation="none"
                                            closable
                                            hideMobileKeyboard
                                        />
                                    </Form.Field>
                                    <Form.Field style={{ margin: 0 }}>
                                        <label style={{ fontSize: "0.85rem", fontWeight: 600, color: "#555", marginBottom: "0.4rem", display: "block" }}>
                                            Dátum do
                                        </label>
                                        <DateInput
                                            fluid
                                            localization="sk"
                                            placeholder="DD.MM.YYYY"
                                            dateFormat="DD.MM.YYYY"
                                            value={filters.to}
                                            onChange={(e, { value }) => setFilters({ ...filters, to: value })}
                                            iconPosition="right"
                                            animation="none"
                                            closable
                                            hideMobileKeyboard
                                        />
                                    </Form.Field>
                                    <Button
                                        fluid
                                        type="submit"
                                        disabled={isLoading || (filters.from === "" || filters.to === "")}
                                        style={{
                                            background: "var(--primary)",
                                            color: "#fff",
                                            borderRadius: "6px",
                                            fontWeight: 600,
                                            padding: "0.85rem 1.5rem",
                                            border: "none",
                                            minWidth: isMobile ? "100%" : "120px"
                                        }}
                                    >
                                        Potvrdiť
                                    </Button>
                                </div>
                            </Form>
                        </Card.Content>
                    </Card>
                )}

                {isLoading
                    ? <Loading />
                    : <StornoRecordsTable records={records} />
                }
            </section>
        </Fragment>
    );
};

export default MyStorno;